import { render, staticRenderFns } from "./searchSuggestLaw.vue?vue&type=template&id=74370b5c&scoped=true&"
import script from "./searchSuggestLaw.vue?vue&type=script&lang=js&"
export * from "./searchSuggestLaw.vue?vue&type=script&lang=js&"
import style0 from "./searchSuggestLaw.vue?vue&type=style&index=0&id=74370b5c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74370b5c",
  null
  
)

export default component.exports